// ----------------------------------------------------------------------------

function getPosition(element: HTMLElement, rowIndex: number, columnIndex: number): HTMLTableCellElement | undefined {
    const elTableBody = element.querySelector('tbody');

    if (!elTableBody) {
        return;
    }

    const elRow = elTableBody.rows[rowIndex];

    if (!elRow) {
        return;
    }

    const elCell = elRow.cells[columnIndex];

    if (!elCell) {
        return;
    }

    return elCell;
}

// ----------------------------------------------------------------------------

export default getPosition;
